/**
 * @generated SignedSource<<7ef3b8dbc8814ace2fa296551f11719c>>
 * @relayHash 71e3c04d84b715444a2256ab97b1451c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ce1a8e2a51b57aeef9bcd01e8b91c6498e7795ac33468994bb4d00626639e0d1

import type { ConcreteRequest } from 'relay-runtime';
export type TqlExplainerAggQuery$variables = {
  containerId: string;
  directoryViewId?: string | null;
  hasTqlOrViewUuid: boolean;
  searchString?: string | null;
};
export type TqlExplainerAggQuery$data = {
  readonly goals_explainSearch?: {
    readonly explanation: string | null;
  } | null;
};
export type TqlExplainerAggQuery = {
  response: TqlExplainerAggQuery$data;
  variables: TqlExplainerAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "directoryViewId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasTqlOrViewUuid"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchString"
},
v4 = [
  {
    "condition": "hasTqlOrViewUuid",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "containerId"
          },
          {
            "kind": "Variable",
            "name": "directoryViewId",
            "variableName": "directoryViewId"
          },
          {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
          }
        ],
        "concreteType": "TownsquareSearchExplanation",
        "kind": "LinkedField",
        "name": "goals_explainSearch",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "explanation"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TqlExplainerAggQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "TqlExplainerAggQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "id": "ce1a8e2a51b57aeef9bcd01e8b91c6498e7795ac33468994bb4d00626639e0d1",
    "metadata": {},
    "name": "TqlExplainerAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9c12d1387f59afb44d3255da03c3fdfb";

export default node;
